import { useEffect, useRef } from 'react'
import styles from './styles.module.css'
import CustomSelect from '../../../components/CustomSelect'
import Leaf from '../../../components/Leaf'
import Button from '../../../components/Button'
import { useDispatch } from 'react-redux'
import { createNotification } from '../../../components/Notifications/Notifications'
import { getThemePlanning } from '../../../actions/planning'

const SearchPanel = ({ formData, setFormData, teachers, handleInputChange, weekNowToPast, schoolYears, lessons }) => {

  const dispatch = useDispatch();

  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    if (formData.week && formData.teacher) {
      setFormData(fd => ({ ...fd, lesson: '0' }));
      dispatch(getThemePlanning(formData.teacher, 0, formData.week, formData.type));
    }
  }, [formData.week, formData.teacher]);

  const handleCustomChange = (name, value) => {
    handleInputChange({ target: { name, value } });
  };

  const handleGetList = () => {
    if (formData.teacher && formData.week) {
      dispatch(getThemePlanning(formData.teacher, formData.lesson || 0, formData.week, formData.type));
    } else {
      createNotification('error', 'Выберите преподавателя и неделю');
    }
  }

  return (
    <div className={styles.wrapper}>

      <div className={styles.row}>

        <div className={styles.selectWrapper}>
          <CustomSelect
            title="Учебный год"
            valuesName="scYear"
            value={formData?.scYear}
            setFieldValue={handleCustomChange}
            withoutAll={true}
            placeholder="Выбрать"
            width="100%"
            options={schoolYears?.map(el => ({ name: el.name, value: el.xp_key }))}
          />
        </div>

        <Leaf
          title="Неделя"
          name={"week"}
          options={weekNowToPast}
          setFormData={setFormData}
          formData={formData}
        />

        <div className={styles.selectWrapper}>
          <CustomSelect
            title="Преподаватель"
            valuesName="teacher"
            value={formData?.teacher}
            setFieldValue={handleCustomChange}
            withoutAll={true}
            placeholder="Выбрать"
            width="100%"
            options={[
              { name: 'Выбрать', value: '' },
              ...teachers?.map(el => ({ name: el.calc_fio || el.fio || el.name, value: el.mid }))
            ]}
          />
        </div>

        <div className={styles.selectWrapper}>
          <CustomSelect
            title="Предмет"
            valuesName="lesson"
            value={formData?.lesson}
            setFieldValue={handleCustomChange}
            withoutAll={true}
            placeholder="Все"
            width="100%"
            options={[
              { name: 'Все', value: '0' },
              ...lessons?.map(el => ({ name: el.title || el.name, value: el.cid }))
            ]}
          />
        </div>

        <Button onClick={handleGetList}>Обновить</ Button>
      </div>

    </div>
  )
}

export default SearchPanel
